import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { sendEvent } from '../../shared/search-event';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import ContributorResultsContext, { reducer, defaultState } from './contributor-results-components/context';
import WiresContainer from './contributor-results-components/wires-container';
import Profile from './contributor-results-components/profile';
import TopKeywords from './contributor-results-components/top-keywords';
import TopStockCodes from './contributor-results-components/top-stock-codes';
import Colleagues from './contributor-results-components/colleagues';
import SimilarContributors from './contributor-results-components/similar-contributors';

const Columnar = styled.div`
  padding-top: ${props => (props.theme.isDesktop ? 49 : 25)}px;

  & section.sidebar > article:first-child {
    margin-top: 0;
  }
`;

export default function SearchResultsContributor({
  profile,
  isProfileFollowedByCurrentUser,
  isOfCurrentUser,
  isScrollable,
  activeTab,
}) {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const isDesktop = useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMax})` });
  const [st, dispatch] = React.useReducer(reducer, defaultState);

  React.useEffect(() => {
    (async () => sendEvent())();
  }, []);

  const className = isDesktop || isMobile ? 'columnar' : 'columnar no-sidebar';

  return (
    <ThemeProvider theme={{ ...theme, isDesktop }}>
      <ContributorResultsContext.Provider value={{ state: st, dispatch }}>
        <React.Fragment>
          <Columnar className={className}>
            <section className="content">
              <Profile {...{ profile, isProfileFollowedByCurrentUser, isOfCurrentUser }} />
              {!isDesktop && (
                <React.Fragment>
                  <TopKeywords profile={profile} />
                  <TopStockCodes profile={profile} />
                  <Colleagues profile={profile} />
                  <SimilarContributors profile={profile} />
                </React.Fragment>
              )}
              <WiresContainer
                profile={profile}
                isScrollable={isScrollable}
                tab={activeTab}
              />
            </section>
            {isDesktop && (
              <section className="sidebar">
                <TopKeywords profile={profile} />
                <TopStockCodes profile={profile} />
                <Colleagues profile={profile} />
                <SimilarContributors profile={profile} />
              </section>
            )}
          </Columnar>
        </React.Fragment>
      </ContributorResultsContext.Provider>
    </ThemeProvider>
  );
}

SearchResultsContributor.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    contributorOrEditor: PropTypes.bool.isRequired,
  }).isRequired,
  isProfileFollowedByCurrentUser: PropTypes.bool.isRequired,
  isOfCurrentUser: PropTypes.bool.isRequired,
  isScrollable: PropTypes.bool,
  activeTab: PropTypes.oneOf(['all', 'latest', 'mentions']).isRequired,
};

SearchResultsContributor.defaultProps = {
  isScrollable: false,
};
